import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Carousel } from '@codex-brightworld/components';

const StyledCarousel = styled(Carousel)`
  max-width: 392px;
  width: auto;
  margin: 0 auto 20px;
  padding: 1px;
  span.dc-icon {
    stroke: none;
    width: 18px;
    height: 18px;
  }
  svg {
    width: 18px;
    height: 18px;
  }
  span[rotate='0'] svg path:last-child {
    stroke: none;
    fill: ${({ selectedSlideIndex, lastSlideIndex, theme }) =>
    (selectedSlideIndex < lastSlideIndex ? theme.colors.primary.purple : theme.colors.neutral.grey[4])};
  }
  span[rotate='180'] svg path:last-child {
    stroke: none;
    fill: ${({ selectedSlideIndex, theme }) =>
    (selectedSlideIndex > 0 ? theme.colors.primary.purple : theme.colors.neutral.grey[4])};
  }
`;

const ImagesGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.lastGroup ? 'flex-start' : 'space-around')};
`;

const ProductImageWrapper = styled.div`
margin: 0 4px 0 4px;
border: ${({ selected }) => (selected ? '2px' : '1px')}
 solid  ${({ selected, theme }) => (selected ? theme.colors.primary.purple : theme.colors.neutral.grey[2])};
cursor: ${({ selected }) => (selected ? 'default' : 'pointer')};
touch-action: pan-y;
border-radius: 50%;
padding: 10px 8px;
max-width: 35px;
max-height: 35px;
`;

const ProductImage = styled.img`
  box-sizing: border-box;
  max-width:100%;
  max-height:100%;
`;

const ProductThumbnailImagesCarousel =
  ({ galleryImages, selectedImageIndex, selectedSlideIndex, onProductImageClick, onSelectedSlideChanged }) => {
    const imagesPerGroup = 5;
    const numberOfImagesGroups = Math.ceil(galleryImages.length / imagesPerGroup);
    const selectedGroup = Math.floor(selectedImageIndex / imagesPerGroup);

    const imagesGroups = [];

    for (let i = 0; i < numberOfImagesGroups; i++) {
      imagesGroups.push(
        <ImagesGroup key={i} lastGroup={i === numberOfImagesGroups - 1}>
          {galleryImages.slice(i * imagesPerGroup, (i * imagesPerGroup) + imagesPerGroup).map(
            (imageData, index) => (
              <ProductImageWrapper
                key={(i * imagesPerGroup) + index}
                selected={selectedImageIndex === ((i * imagesPerGroup) + index)}
                onClick={(e) => {
                  e.preventDefault();
                  if (selectedImageIndex !== ((i * imagesPerGroup) + index)) {
                    onProductImageClick((i * imagesPerGroup) + index);
                  }
                }}
              >
                <ProductImage src={imageData.srcSmall} />
              </ProductImageWrapper>
            )
          )}
        </ImagesGroup>
      );
    }

    return (
      <StyledCarousel
        showNavigation={false}
        selectSlideIndex={selectedGroup}
        selectedSlideIndex={selectedSlideIndex}
        lastSlideIndex={numberOfImagesGroups - 1}
        onSelectedSlideChanged={onSelectedSlideChanged}
      >
        {imagesGroups}
      </StyledCarousel>
    );
  };

ProductThumbnailImagesCarousel.propTypes = {
  galleryImages: PropTypes.arrayOf(PropTypes.shape({
    srcSmall: PropTypes.string.isRequired
  })).isRequired,
  selectedImageIndex: PropTypes.number.isRequired,
  selectedSlideIndex: PropTypes.number.isRequired,
  onProductImageClick: PropTypes.func,
  onSelectedSlideChanged: PropTypes.func
};

ProductThumbnailImagesCarousel.defaultProps = {
  onProductImageClick: () => { },
  onSelectedSlideChanged: () => { }
};

export default ProductThumbnailImagesCarousel;
